<script setup lang="ts">
import CircleLoader from '@ui/components/loader/CircleLoader.vue'
</script>

<template lang="pug">
.drawer-loader.position-absolute.w-100p
  .position-fixed.t-50p
    CircleLoader
</template>

<style scoped>
.drawer-loader {
  left: calc(50% - 20px);
}
</style>
